{
  "footer": {
    "navigation": "Footer",
    "socialMedia": "Social media",
    "newTab": "(opens in a new tab)",
    "pdfDocument": "(PDF)",
    "social": {
      "facebook": "GlobalConnect on Facebook",
      "youtube": "GlobalConnect on YouTube",
      "linkedin": "GlobalConnect on LinkedIn",
      "instagram": "GlobalConnect on Instagram"
    },
    "se": {
      "menus": {
        "globalConnect": "GlobalConnect",
        "purchaseInformation": "Purchase information",
        "customerService": "Customer service"
      },
      "links": {
        "aboutUs": "About GlobalConnect",
        "euProjects": "EU-funded projects",
        "privacyPolicy": "Privacy policy",
        "cookiePolicy": "Cookie policy",
        "career": "Careers",
        "press": "Press",
        "terms": "Terms and conditions",
        "fiberInterest": "Fiber interest registration",
        "leisureHomeServices": "Holiday home services",
        "faq": "Frequently asked questions",
        "contact": "Contact us",
        "serviceStatus": "Service status",
        "landowners": "Landowners",
        "accessibility": "Accessibility"
      }
    },
    "fi": {
      "menus": {
        "globalConnect": "GlobalConnect",
        "support": "Support",
        "termsAndPricing": "Terms and pricing"
      },
      "links": {
        "aboutUs": "About us",
        "career": "Careers",
        "news": "News",
        "media": "For media",
        "sustainability": "Sustainability",
        "businessCustomers": "Business customers",
        "customerService": "Customer service",
        "faq": "Frequently asked questions",
        "cancellationForm": "Cancellation form",
        "serviceStatus": "Service disruptions",
        "cableInformation": "Cable information",
        "accessibility": "Accessibility",
        "priceList": "Price list",
        "salesTerms": "Terms of sale",
        "serviceTerms": "Terms of service",
        "privacyPolicy": "Privacy policy",
        "cookiePolicy": "Cookie policy"
      }
    }
  },
  "errorComponent": {
    "404": "We searched long and hard, but the page you are looking for does not seem to exist",
    "409": "This address is already connected and ready!",
    "500": "Oops, looks like something went wrong unfortunately!",
    "503": "Oops, something went wrong!",
    "statusFallback": "Oops, something went wrong.",
    "buttonTextPublicUrl": "Click here to return to our home page",
    "buttonTextPortalUrl": "Click here to go back"
  },
  "addressComponent": {
    "yourAddress": "Your address",
    "searchNewAddress": "Search new address"
  },
  "addressInfoTranslations": {
    "street": {
      "label": "Street address",
      "placeholder": "Street address"
    },
    "postalCode": {
      "label": "ZIP code",
      "placeholder": "ZIP code",
      "error": {
        "pattern": "ZIP code must be 5 numbers long"
      }
    },
    "city": {
      "label": "county",
      "placeholder": "county"
    },
    "country": "Country",
    "countryCode": {
      "error": {
        "pattern": "Incorrect country code"
      }
    },
    "countries": {
      "sweden": "Sweden",
      "norway": "Norway",
      "aland": "Åland"
    },
    "requiredError": "This field is required",
    "sameBillingAddress": "The billing address is the same as the delivery address"
  },
  "commonInfoTranslations": {
    "phoneNumber": {
      "label": "Phone number",
      "countryCodeTitle":"Country code",
      "placeholder": {
        "+46": "9 digits, example: 701234567",
        "+47": "8 or 12 digits long",
        "+358": "5 to 10 digits long",
        "+999": "+xx xxxxxx"
      },
      "error": {
        "pattern": "Only numbers allowed",
        "lengthNine": "Phone number must be 9 digits long",
        "lengthEightOrTwelve": "Phone number must be 8 or 12 digits long",
        "lengthFiveToTen": "Phone number must be between be 5-10 digits",
        "otherCountryCode": "Phone number should start with '+' followed by digits."
      }
    },
    "email": {
      "label": "Email address",
      "placeholder": "example@email.com",
      "error": {
        "notMatching": "The email addresses must match.",
        "pattern": "The email address must match the format example@email.com"
      }
    },
    "confirmEmail": "Repeat email address",
    "requiredError": "This field is required."
  },
  "earliestActivationDateTranslations": {
    "earliestActivationDate": "Earliest activation date",
    "toolTipInfo": "Earliest start date is determined based on whether the address has active services today. There may be a binding period that blocks the desired start date. To check the possibilities of bringing the start date forward, contact the selected supplier after completing the order."
  }
}
